import { Component } from 'vue-property-decorator'
import Vue from '@src/vue'
import { CreateElement } from 'vue'

@Component
export class DownloadMobileApp extends Vue {

  isAndroid (userAgent) {
    return /android/i.test(userAgent)
  }

  isIOS (userAgent) {
    return /iPad|iPhone|iPod/.test(userAgent)
  }

  beforeMount () {
    const userAgent = navigator.userAgent || navigator.vendor

    if (this.isIOS(userAgent)) {
      document.location.href = 'https://itunes.apple.com/us/app/pixformance/id1290751415?ls=1&mt=8'
    } else if (this.isAndroid(userAgent)) {
      document.location.href = 'https://play.google.com/store/apps/details?id=com.pixformance.app'
    } else {
      document.location.href = 'https://www.pixformance.fit/mobile'
    }
  }

  render (h: CreateElement) {
    return null
  }
}
